/**
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/body/namespaces";
import { onLoad as onLoadEvent } from "@gr-exports/body/dom";
import type { LegacyUtils } from "../deprecated/head";
import { isPreview, isPrivacyPage } from "@gr-exports/body/misc";
import { toggle } from "@gr-exports/body/toggle";

/*    */
/*                                       */
/*  */
/*                                                      */
/*  */
/*       */
/*                                                                     */
/*                                                  */
/*    */
/*                                        */

const win = window;
const log = win.o_global?.debug.logger("exactag.varnish");
const legacy = o_util as unknown as LegacyUtils;
/*                                                     */
const { getConsentForGV, consentChanged } = otto.cmp;

const { host } = win.location;
const env = `${win.location.protocol}/*       */
const varnishURL = `${env}/user/performanceMarketing`;
const firstChar = varnishURL.substring(0, 1);
const { hash } = win.location;
let variationId = "";
const PXC_ENABLED_TOGGLE = "EMR_PXC";
/*                                                            */
const re = /variationId=([a-zA-Z0-9_-]*)/;

const eprivacyConsent = "eprivacy.cmp.consentChanged";

/*                                          */
/*                                                          */
if (re.test(hash)) {
  variationId = `?variationId=${hash.match(re)![1]}`;
}

export type Exactag = Window["lhotse"]["exactag"];

const consents: Exactag["consents"] = {
  [eprivacyConsent]: { received: false, accept: false },
};
const consentResult = { received: false, accept: false };

log.info("construct exactag object");
const exactag: Exactag = Object.assign(win.lhotse.exactag ?? {}, {
  varnish: { version: "0.8.9", data: [] },

  centralFinished: false,
  finished: false,
  /**
 *
 *
 */
  execute: false,

  consents,

  consentResult,

  /*                                                               */
  getVarnishData,
  /*                                                               */
  hasConsent,
  /*                                                               */
  onLoad,
} as Partial<Exactag>);
win.lhotse = { ...win.lhotse, exactag };

/**
 *
 *
 */
export function getVarnishData(url: string): void {
  legacy.ajax
    .getScript(url)
    .then(function (xhr) {
      /*                                                  */
      /*                                                                     */
      if (xhr.status === 200 || xhr.status === 304) {
        /*                                  */
        /*                                                      */
        exactag.finished = true;

        /*                                                                                     */
        /*                                                                                    */
        if (exactag.centralFinished) {
          exactag.continueTrack();
        }
      } else {
        /*                                  */
        const msg = `Triggered ajaxError handler in '${varnishURL}'! Status: ${xhr.status}`;

        /*                        */
        log.debug(msg);
      }
    })
    .catch((e: Error) => {
      log.warn(e.message);
    });
}

export function execute(): void {
  /*                                                                                                 */
  if (exactag.varnishURL) {
    if (firstChar === "." || firstChar === "/") {
      getVarnishData(varnishURL);
    }
  } else {
    getVarnishData(varnishURL + variationId);
  }
}

export async function processConsentAnswer(consent: string, yes: boolean | null): Promise<void> {
  consents[consent].received = true;
  consents[consent].accept = !!yes;

  /**
 *
 */
  const consentResult = { received: true, accept: true };
  exactag.consentResult = consentResult;

  Object.keys(consents).forEach((k) => {
    consentResult.received = consentResult.received && consents[k].received;
    consentResult.accept = consentResult.accept && consents[k].accept;
  });

  /*                                            */
  if (consentResult.received && consentResult.accept) {
    exactag.execute = true;
    execute();
  }
}

/**
 *
 *
 */
export async function onLoad(): Promise<void> {
  exactag.getConsentForGV = await getConsentForGV;

  processConsentAnswer(eprivacyConsent, await exactag.hasConsent());

  /*                                           */
  /*                  */
  /*                                            */
  if (!consentResult.received) {
    /*                                 */
    execute();
  }
}

export async function hasConsent(): Promise<boolean> {
  try {
    return (
      /*                                             */
      toggle.get(PXC_ENABLED_TOGGLE, true) &&
      /*                      */
      !isPreview(window.location.href) &&
      /*                      */
      !isPrivacyPage() &&
      /*              */
      !!(await getConsentForGV("OTTOT"))
    );
  } catch {
    return false;
  }
}

log.info("Subscribe to eprivacy consent changed event");
/*                                                     */
consentChanged.sub(async () => {
  /*                                                                           */
  exactag.getConsentForGV = await getConsentForGV;
  await exactag.addPartnerConsents();
  processConsentAnswer(eprivacyConsent, await exactag.hasConsent());
});

log.info("Subscribe to onLoad event");
onLoadEvent.sub(onLoad);
